import React from 'react';

const mediaLinks = [
  {
    source: 'Startup Pakistan', mark: 'SP', type: 'Facebook feature',
    title: 'Pakistan’s First Space-Themed Telefilm Premieres at IST',
    url: 'https://www.facebook.com/startupkhipk/photos/pakistans-first-space-themed-telefilm-jahan-aur-bhi-hain-beyond-the-blue-premier/588478444276460/',
  },
  {
    source: 'The Nation', mark: 'TN', type: 'News article',
    title: 'Pakistan’s First Space Telefilm Blasts Off with a Climate Warning',
    url: 'https://www.nation.com.pk/06-Jun-2025/jahan-aur-bhi-hain-pakistan-s-first-space-telefilm-blasts-off-with-a-climate-warning',
  },
  {
    source: 'The Current', mark: 'TC', type: 'Entertainment feature',
    title: 'Pakistan’s First Space Telefilm Looks Like a Blast',
    url: 'https://thecurrent.pk/pakistans-first-space-telefilm-jahan-aur-bhi-hain-looks-like-a-blast/',
  },
  {
    source: 'UrduPoint', mark: 'UP', type: 'News article',
    title: 'Pakistan’s First Space-Themed Telefilm Jahan Aur Bhi Hain',
    url: 'https://www.urdupoint.com/en/pakistan/pakistans-first-space-themed-telefilm-jah-1987987.html',
  },
  {
    source: 'Associated Press of Pakistan', mark: 'APP', type: 'National news',
    title: 'Space Meets Cinema: Beyond the Blue Set to Premiere at IST',
    url: 'https://www.app.com.pk/national/space-meets-cinema-pakistans-first-space-drive-telefilm-jahan-aur-bhi-hain-beyond-the-blue-set-to-premiere-at-ist/',
  },
  {
    source: 'ProPakistani', mark: 'PP', type: 'Entertainment feature',
    title: 'Pakistan’s First Space-Themed Telefilm Set for Islamabad Premiere',
    url: 'https://propakistani.pk/lens/pakistans-first-space-themed-telefilm-jahan-aur-bhi-hain-set-for-islamabad-premiere/',
  },
  {
    source: 'YouTube', mark: '▶', type: 'Video coverage',
    title: 'Jahan Aur Bhi Hain — Beyond the Blue Media Feature',
    url: 'https://www.youtube.com/watch?v=6VAhHz5Z7tg',
  },
];

const FilmMediaCoverage = () => (
  <section className="film-media-coverage" aria-labelledby="film-media-coverage-title">
    <div className="summer-school-media-inner">
      <header className="summer-school-media-header">
        <p className="section-eyebrow">IN THE NEWS</p>
        <h2 id="film-media-coverage-title">Media Coverage</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
      </header>

      <div className="summer-school-media-grid">
        {mediaLinks.map((item) => (
          <a
            className="summer-school-media-card"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            key={item.url}
            aria-label={`Open ${item.title} from ${item.source}`}
          >
            <div className="summer-school-media-logo-wrap">
              <div className="film-media-source-mark" aria-hidden="true">{item.mark}</div>
            </div>
            <div className="summer-school-media-copy">
              <div className="summer-school-media-meta">
                <span>{item.source}</span>
                <span>{item.type}</span>
              </div>
              <h3>{item.title}</h3>
              <span className="summer-school-media-link">
                {item.type === 'Video coverage' ? 'Watch video' : 'Open coverage'} <span aria-hidden="true">→</span>
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default FilmMediaCoverage;
